import * as React from 'react';
import { Route } from 'react-router-dom';
import MaasZonesList from '@features/maas-editor/MaasList';
import MaasZoneEdit from '@features/maas-editor/MaasZoneEdit';
import LayersListWrapper from '@features/map-layers-list/layers-list/LayersListWrapper';
import LazyLoadingWrapper from '@components/LazyLoadingWrapper/LazyLoadingWrapper';
import LayersTimeSelectors from '@features/map-layers-list/time-selector/LayersTimeSelectors';
import BreadcrumbedComponent from '@components/BreadcrumbedComponent/BreadcrumbedComponent';

const MaasEditor = React.lazy(() => import('../../pages/ProjectModes/MaasModePage'));

export const useMaasRoutes = () => {
    return (
        <Route path="maas" element={<LazyLoadingWrapper element={<MaasEditor />} />}>
            <Route
                element={<BreadcrumbedComponent />}
                handle={{ crumb: (data: any) => ({ name: 'MaaS zones', ...data }) }}
            >
                <Route index element={<MaasZonesList />} />
                <Route path="new" element={<MaasZoneEdit />} />
                <Route
                    path=":zoneId/edit"
                    element={<MaasZoneEdit />}
                    loader={({ params }) => params}
                    handle={{ crumb: ({ zoneId }) => ({ id: zoneId }) }}
                />
                <Route
                    path="layers"
                    element={
                        <LayersListWrapper>
                            <LayersTimeSelectors />
                        </LayersListWrapper>
                    }
                />
            </Route>
        </Route>
    );
};
